import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import SystemCard from "components/SystemCard";
import { EbdaEduAdminPanelSettings } from "constants/constants";
import { useLanguage } from "context/LanguageContext";
import { useMemo, useState } from "react";
import Popup from '../../components/Popup';
import { useTheme } from "context/ThemeContext";
import { useEbdaEduAuth } from "context/EbdaEduAuthContext";

const EbdaEduAdminPanel = () => {
    const { ebdaUserInfo } = useEbdaEduAuth();
    const { language } = useLanguage();
    const { darkMode } = useTheme();
    const [notAvailable, setNotAvailable] = useState(false);
    const settings = useMemo(
        () => EbdaEduAdminPanelSettings(language, ebdaUserInfo),
        [language, ebdaUserInfo]
    );

    const openPopup = () => {
        setNotAvailable(true);
    };

    return (
        <div className={`min-h-screen ${darkMode ? 'bg-watomsBlue text-white' : 'bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-900'}`}>
            <EbdaEduNavbar />
            {/* Main Body */}
            <div className={`relative z-10 px-6 pb-5`}>
                {/* Admin Panel Settings Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-12 max-w-7xl mx-auto">
                    {settings.map(setting => (
                        <SystemCard
                            key={setting.id}
                            openPopup={() => openPopup()}
                            available={setting.available}
                            path={setting.path}
                            color={setting.color}
                            iconType="awesome"
                            icon={setting.icon}
                            title={setting.title}
                            subtitle={setting.subtitle}
                        />
                    ))}
                </div>
            </div>
            <Popup
                isOpen={notAvailable}
                onClose={() => setNotAvailable(false)}
                message={language ? "This system will be available soon" : "هذا النظام سيتم إطلاقه قريباً"}
                button={language ? "OK" : "حسناً"}
                form={false}
            />
        </div>
    )
};

export default EbdaEduAdminPanel;